module.exports = "/_next/static/images/game-1-phone-uv-lock-c82e159ecf3c03641e2c5bc7ba36830c.png";